import { ISinhVienSearchRequest } from "../../model/request/sinh-vien/ISinhVienSearchRequest";
import { ISinhVienSelectByLopsRequest } from "../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { ISinhVienUpdateDanhBaRequest } from "../../model/request/sinh-vien/ISinhVienUpdateDanhBaRequest";
import { apiClient, formatQueryString } from "../apiClient";
export const sinhVienApi = {
  SelectByLops: (request: ISinhVienSelectByLopsRequest) =>
    apiClient.post(`sinh-vien`, request),
  SelectById: (id_sv: string) =>
    apiClient.get(`sinh-vien/select-by-id/${id_sv}`),
  Search: (request: ISinhVienSearchRequest) =>
    apiClient.get(`sinh-vien/search?${formatQueryString(request)}`),
  UpdateDanhBa: (request: ISinhVienUpdateDanhBaRequest) =>
    apiClient.put(`sinh-vien/update-danh-ba`, request),
};
